import { render, staticRenderFns } from "./FormComponentChat.vue?vue&type=template&id=66935c4b"
import script from "./FormComponentChat.vue?vue&type=script&lang=js"
export * from "./FormComponentChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports